module.exports = __webpack_public_path__ + "img/banner2.4dad70e6.jpg";